// Raggruppamento dei comandi del pannello «Comandi manuali attivi»: per impianto, con in cima gli impianti che hanno comandi ancora in corso.
import type { RigaLogComando } from "~~/shared/data-model/log_comandi";

export interface GruppoImpiantoComandi {
  /** `null` = comandi senza impianto (non dovrebbero esserci: si raggruppano insieme). */
  idImpianto: number | null;
  nome: string;
  righe: RigaLogComando[];
  inCorso: number;
}

export function raggruppaPerImpianto(righe: readonly RigaLogComando[]): GruppoImpiantoComandi[] {
  const gruppi = new Map<number | null, GruppoImpiantoComandi>();
  for (const riga of righe) {
    const id = riga.impianto?.id ?? null;
    const gruppo = gruppi.get(id) ?? { idImpianto: id, nome: riga.impianto?.nome ?? "—", righe: [], inCorso: 0 };
    gruppo.righe.push(riga);
    if (riga.esito === "in_corso") gruppo.inCorso += 1;
    gruppi.set(id, gruppo);
  }
  // con più impianti in corso prima quelli con più comandi in corso; a parità l'ordine di arrivo (i comandi sono già dal più recente)
  return [...gruppi.values()].sort((a, b) => b.inCorso - a.inCorso);
}
